import { Link } from "react-router-dom";
import topics from "./topics";
import useTitle from "./useTitle";

const LEVELS = [
    ["s3", "中三", "Secondary 3"],
    ["s4", "中四", "Secondary 4"],
    ["s5", "中五", "Secondary 5"],
    ["s6", "中六", "Secondary 6"],
];

const Syllabus = () => {
    useTitle("中學數學課程進度表｜中三至中六 HK Maths Syllabus");
    return (
    <div className="topic-page">
        <h1>中學數學課程進度表</h1>
        <h2 className="topic-en">HK Secondary Maths Syllabus — Chapter by Chapter</h2>
        <p className="topic-intro">
            香港中三至中六數學（必修部分）各級課題一覽。撳課題名入去就有該課題的重點公式、常犯錯誤，以及免費練習 PDF（中英雙版，附答案）。
        </p>
        {LEVELS.map(([lvl, zh, en]) => {
            const list = topics.filter((t) => t.level === lvl);
            return (
                <div key={lvl}>
                    <h3><Link to={`/${lvl}`}>{zh}數學 {en}</Link>（{list.length} 個課題）</h3>
                    <p className="level-notes-link">
                        <Link to={`/${lvl}/notes`}>{zh}數學筆記（公式總表＋常犯錯誤，可下載 PDF）→</Link>
                    </p>
                    <ol className="syllabus-list">
                        {list.map((t) => (
                            <li key={t.slug}>
                                <Link to={`/${lvl}/${t.slug}`}>{t.zh}</Link>
                                <span className="syllabus-en"> {t.en}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            );
        })}
    </div>
    );
};

export default Syllabus;
